/**
 * - This file is the delegate of the general app behaviors.
 *
 * - All modules are namespaced in order that each one could
 * be access by its name like
 * ...mapState({
 *     user: state => state.session.user
 * })
 *
 * Or
 *
 * ...mapActions({
 *     login: 'session/login'
 * })
 */

import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import languages from '../assets/lang'
import { setCookie, getCookie } from '@/helpers/storage'

const allowPrototypedErrors = false;
const allowsCookieLanguage = false;

Vue.use(Vuex);

export default new Vuex.Store({
    modules,
    state: {
        errors: {},
        lang: allowsCookieLanguage && localStorage.getItem(process.env.VUE_APP_USER_PREFERRED_LANGUAGE) ? localStorage.getItem(process.env.VUE_APP_USER_PREFERRED_LANGUAGE) : 'es'
    },
    mutations: {
        TRANSLATE: (state, lang) => state.lang = lang,
        CLEAR_ERRORS: state => state.errors = {},
        REMOVE_ERROR: (state, error) => delete state.errors[error],
        SET_ERRORS: (state, errors) => state.errors = errors
    },
    actions: {
        /**
         *
         * @param {function} commit
         * @param {string} lang
         */
        translate({ commit }, lang = 'en') {
            if (lang) {
                if (lang.length) {
                    if (allowsCookieLanguage) {
                        localStorage.setItem(process.env.VUE_APP_USER_PREFERRED_LANGUAGE, lang);
                        location.reload()
                    } else {
                        commit('TRANSLATE', lang)
                    }
                }
            }
        },

        /**
         *
         * @param {function} commit
         * @param {object} errors
         */
        setErrors({ commit }, errors) {
            commit('SET_ERRORS', errors)
        },

        /**
         *
         * @param {function} commit
         * @param {string} error
         */
        removeError({ commit }, error) {
            commit('REMOVE_ERROR', error)
        }
    },
    getters: {
        /**
         *
         * @param {object} state
         * @returns {function(*=): boolean}
         */
        hasError: state => error => state.errors.hasOwnProperty(error),

        /**
         *
         * @param {object} state
         * @returns {function(*): *}
         */
        getError: state => error => state.errors[error] ? state.errors[error][0] : "",

        /**
         *
         * @param {object} state
         * @returns {*}
         */
        lang: state => languages[state.lang],

        /**
         *
         * @param {object} state
         * @param {object} lang
         * @param {function} getError
         * @returns {function(...[*]=)}
         */
        getTranslatedError: (state, { lang, getError }) => (error, ...args) => {
            let gotten = getError(error);
            if (allowPrototypedErrors) {
                let translated = lang.errors[gotten];
                let globalReg = /#match#/g;
                let singleReg = /#match#/;
                if (translated) {
                    let matchs = translated.match(globalReg);
                    for (let match in matchs) {
                        translated = translated.replace(singleReg, args[match] || "elemento")
                    }

                    return translated || null
                }
                return null
            }

            return gotten || null
        }
    }
})